import { Menu } from '@pocketlaw/tetris';
import { isValid, format } from 'date-fns';
import { localeConfig } from 'shared/domains/languages';
import { MenuFooter } from './MenuFooter';
export function DateMenu(props) {
    const { property, initialValue, onChange, onClear } = props;
    const { label } = property;
    const localeCode = localeConfig.getActiveLocale().code;
    const validValue = initialValue && isValid(new Date(initialValue)) ? new Date(initialValue) : undefined;
    const handleDateChange = (date) => {
        const formattedDate = format(date, 'yyyy-MM-dd');
        onChange(property, formattedDate);
    };
    const handleClear = () => {
        onClear(property);
    };
    return (<Menu.ItemNested target={label}>
      <Menu.Calendar locale={localeCode} value={validValue} onChange={handleDateChange}/>
      <MenuFooter onClear={handleClear}/>
    </Menu.ItemNested>);
}
